import React, { useState } from "react";
import "./ContactezNous.css";
import Logo from "./Logo.png";

export default function ContactezNous() {
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [reason, setReason] = useState("");
  const [confirmed, setConfirmed] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const isValidEmail = (e: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);

  const canSubmit =
    confirmed &&
    email.trim() !== "" &&
    isValidEmail(email) &&
    firstName.trim() !== "" &&
    lastName.trim() !== "";

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!canSubmit) return;
    console.log({ email, firstName, lastName, reason, confirmed });
    setSubmitted(true);
  };

  return (
    <div className="cn-page">
      {/* ── Top bar ── */}
      <div className="cn-topbar">
        <a href="/" className="cn-topbar-brand">
          <span className="cn-topbar-dot"></span>
          <span className="cn-topbar-name">Wyn<span>.ma</span></span>
        </a>
        <a href="/" className="cn-topbar-back">
          <i className="bi bi-arrow-left"></i>
          <span>Retour à l'accueil</span>
        </a>
      </div>

      {/* ── Main ── */}
      <div className="cn-main">
        <div className="cn-card">
          {/* Icon */}
          <div className="cn-icon-wrap">
            <div className="cn-icon-circle">
              <i className="bi bi-shield-exclamation"></i>
            </div>
          </div>

          {/* Title */}
          <h1 className="cn-title">Suppression de données</h1>
          <p className="cn-subtitle">
            Demande de suppression complète et définitive de vos données
            personnelles conformément au RGPD
          </p>

          {/* Warning */}
          <div className="cn-warning">
            <div className="cn-warning-icon">
              <i className="bi bi-exclamation-triangle"></i>
            </div>
            <div className="cn-warning-text">
              <strong>Attention :</strong> Cette action est irréversible. Toutes
              les données associées à votre compte seront définitivement
              supprimées de nos serveurs.
            </div>
          </div>

          {/* Steps */}
          <div className="cn-steps">
            <div className={`cn-step ${!submitted ? "active" : "done"}`}>
              <span className="cn-step-num">
                {submitted ? <i className="bi bi-check-lg"></i> : "1"}
              </span>
              <span className="cn-step-label">Formulaire</span>
            </div>
            <div className={`cn-step-line ${submitted ? "done" : ""}`}></div>
            <div className={`cn-step ${submitted ? "active" : ""}`}>
              <span className="cn-step-num">2</span>
              <span className="cn-step-label">Vérification</span>
            </div>
            <div className="cn-step-line"></div>
            <div className="cn-step">
              <span className="cn-step-num">3</span>
              <span className="cn-step-label">Suppression</span>
            </div>
          </div>

          {/* Form card */}
          <div className="cn-form-card">
            {!submitted ? (
              <form onSubmit={handleSubmit}>
                {/* Email */}
                <div className="cn-group">
                  <label className="cn-label">Adresse email du compte</label>
                  <div className="cn-input-wrap">
                    <i className="bi bi-envelope cn-field-icon"></i>
                    <input
                      className="cn-input"
                      type="email"
                      placeholder="votre@email.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                </div>

                {/* Name row */}
                <div className="cn-row">
                  <div className="cn-group">
                    <label className="cn-label">Prénom</label>
                    <div className="cn-input-wrap">
                      <i className="bi bi-person cn-field-icon"></i>
                      <input
                        className="cn-input"
                        type="text"
                        placeholder="Votre prénom"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  <div className="cn-group">
                    <label className="cn-label">Nom</label>
                    <div className="cn-input-wrap">
                      <i className="bi bi-person cn-field-icon"></i>
                      <input
                        className="cn-input"
                        type="text"
                        placeholder="Votre nom"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                </div>

                {/* Reason (optional) */}
                <div className="cn-group">
                  <label className="cn-label">
                    Raison de la suppression{" "}
                    <span style={{ color: "#94A3B8", fontWeight: 400, textTransform: "none" }}>
                      (optionnel)
                    </span>
                  </label>
                  <textarea
                    className="cn-textarea"
                    placeholder="Dites-nous pourquoi vous souhaitez supprimer vos données..."
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    rows={3}
                  />
                </div>

                {/* Data to be deleted */}
                <div className="cn-data-list">
                  <div className="cn-data-list-title">
                    Données qui seront supprimées
                  </div>
                  <div className="cn-data-item">
                    <i className="bi bi-person-x"></i>
                    <span>Informations personnelles (nom, email, téléphone)</span>
                  </div>
                  <div className="cn-data-item">
                    <i className="bi bi-cart-x"></i>
                    <span>Historique de commandes et transactions</span>
                  </div>
                  <div className="cn-data-item">
                    <i className="bi bi-chat-square-dots"></i>
                    <span>Messages et tickets de support</span>
                  </div>
                  <div className="cn-data-item">
                    <i className="bi bi-database-x"></i>
                    <span>Toutes les données associées au compte</span>
                  </div>
                </div>

                <div className="cn-divider"></div>

                {/* Checkbox */}
                <div className="cn-checkbox-wrap" onClick={() => setConfirmed(!confirmed)}>
                  <input
                    type="checkbox"
                    className="cn-hidden-check"
                    checked={confirmed}
                    readOnly
                  />
                  <div className={`cn-custom-check ${confirmed ? "checked" : ""}`}>
                    {confirmed && <i className="bi bi-check-lg"></i>}
                  </div>
                  <span className="cn-checkbox-text">
                    Je confirme vouloir la <strong>suppression totale et irréversible</strong> de
                    toutes les données liées à cet email. Je comprends que cette action ne peut pas
                    être annulée.
                  </span>
                </div>

                {/* Submit */}
                <button className="cn-submit" type="submit" disabled={!canSubmit}>
                  <i className="bi bi-trash3"></i>
                  Confirmer la suppression
                </button>
              </form>
            ) : (
              /* ── Success state ── */
              <div className="cn-success">
                <div className="cn-success-icon">
                  <i className="bi bi-check-circle"></i>
                </div>
                <h3>Demande envoyée avec succès</h3>
                <p>
                  Votre demande de suppression de données a été enregistrée. Notre
                  équipe traitera votre demande dans un délai maximum de{" "}
                  <strong>30 jours</strong>.
                </p>
                <p>
                  Un email de confirmation sera envoyé à <strong>{email}</strong>.
                </p>
              </div>
            )}
          </div>

          {/* RGPD note */}
          <div className="cn-rgpd">
            <i className="bi bi-shield-check"></i>
            <span className="cn-rgpd-text">
              <strong>RGPD</strong> — Cette demande sera traitée conformément au
              Règlement Général sur la Protection des Données. Délai de traitement :
              30 jours maximum.
            </span>
          </div>
        </div>
      </div>

      {/* ── Footer ── */}
      <footer className="cn-footer">
        <div className="cn-footer-grid">
          <div className="cn-footer-brand">
            <p>
              Avec plus de 30 000 références en stock, et le rapport le plus détaillé
              des spécifications de fabrication de tous ses produits, Wyn met à la
              disposition de ses clients le meilleur service du secteur.
            </p>
            <img src={Logo} alt="Wyn.ma" />
          </div>

          <div>
            <div className="cn-footer-title">Pages</div>
            <ul className="cn-footer-links">
              <li>
                <a href="/">
                  <i className="bi bi-chevron-right"></i> Accueil
                </a>
              </li>
              <li>
                <a href="/visiteurs">
                  <i className="bi bi-chevron-right"></i> Voir les articles
                </a>
              </li>
              <li>
                <a href="/connecter_compte">
                  <i className="bi bi-chevron-right"></i> Connecter comme visiteur
                </a>
              </li>
              <li>
                <a href="/informations">
                  <i className="bi bi-chevron-right"></i> Politique de
                  confidentialité
                </a>
              </li>
            </ul>
          </div>

          <div className="cn-footer-contact">
            <div className="cn-footer-title">Contactez nous</div>
            <p>
              <i className="bi bi-geo-alt-fill"></i>
              Imm Lotf-Allah Angle Bd La Grande Ceinture et Ibn Al Adraa Al
              Morrakochi, Casablanca
            </p>
            <p>
              <i className="bi bi-whatsapp"></i>
              +212 693-693694
            </p>
            <p>
              <i className="bi bi-envelope"></i>
              Contact@wyn.ma
            </p>
          </div>
        </div>

        <div className="cn-footer-bottom">
          © {new Date().getFullYear()} Wyn.ma — Tous droits réservés
        </div>
      </footer>
    </div>
  );
}